<template>
  <Layout>
    <PageHeader :title="title" :items="items"></PageHeader>
    <div class="row" id="dataFilters">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center mb-4">
              <div class="col-md-6">
                <div class="form-inline navbar-search">
                  <div class="input-group">
                    <input name="title" class="form-control bg-light border-0 small" placeholder="Search..."
                      aria-label="Search" aria-describedby="basic-addon2" v-model="filter" v-on:keyup="search" />
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="searchFor">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="d-flex align-items-center justify-content-end" v-if="can('add-dataFilters')">
                  <svg class="svg-inline--fa fa-table mx-2" height="16px" width="16px" aria-hidden="true"
                    focusable="false" data-prefix="fa" data-icon="table" role="img" xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512" data-fa-i2svg="">
                    <path fill="currentColor"
                      d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z">
                    </path>
                  </svg>
                  <router-link :to="{ name: 'add-dataFilters' }" class="opt">Add Data Filter</router-link>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table :items="tableData.data" :fields="fields" :sort-by.sync="sortBy" :per-page="0"
                :current-page="currentPage" :sort-desc.sync="sortDesc" :filter-included-fields="filterOn"
                @filtered="onFiltered" responsive="sm" class="table-bordered table-hover" :key="key">
                <template v-slot:cell(created_from)="row">
                  <template v-if="row.item.created_from == 'partner'">
                      <span class="badge badge-primary">Partner Panel</span>
                  </template>
                  <template v-else>
                      <span class="badge badge-success">Medisage Panel</span>
                  </template>
                </template>
                <template v-can="'edit-dataFilters'" v-slot:cell(edit)="row">
                  <template v-if="row.item.created_from == 'partner'">
                    <i class="fa fa-edit is_processed_edit"></i>
                  </template>
                  <template v-else>
                    <router-link :to="{
                      name: 'edit-dataFilters',
                      params: { id: row.item.id },
                    }">
                      <i class="fa fa-edit edit-i"></i>
                    </router-link>
                  </template>
                </template>
                <template v-slot:cell(delete)="row">
                  <div v-if="activeTab == 'trash' && can('restore-dataFilters')"
                    @click.prevent="restoreDataFilters(row.item.id)">
                    <i class="mdi mdi-restore restore-i"></i>
                  </div>
                  <template v-else-if="activeTab != 'trash' && can('delete-dataFilters')">
                    <template v-if="row.item.created_from == 'partner'">
                      <i class="mdi mdi-trash-can is_processed_delete"></i>
                    </template>
                    <template v-else>
                      <div @click.prevent="deleteDataFilters(row.item.id)">
                        <i class="mdi mdi-trash-can delete-i"></i>
                      </div>
                    </template>
                  </template>
                </template>
              </b-table>
            </div>
            <template v-if="tableData.total_pages > 1">
              <div class="data_paginate">
                <div class="dataTables_paginate paging_simple_numbers d-flex justify-content-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" first-number last-number :total-rows="tableData.total"
                      :total-pages="tableData.total_pages" :per-page="tableData.per_page"></b-pagination>
                  </ul>
                </div>
                <div class="form-inline navbar-search">
                  <span class="mr-2">Go to a Particular Paginated Page :</span>
                  <div class="input-group">
                    <b-form-input id="case" v-model="pageNo" placeholder="Enter Page No" class="in-width">
                    </b-form-input>
                    <div class="input-group-append">
                      <button class="btn btn-search" @click="filterPage">
                        <i class="fas fa-search fa-sm"> </i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import MixinRequest from "../../../mixins/request";
import datafilterMixin from "../../../mixins/ModuleJs/data-filters";

export default {
  data() {
    return {
      title: "Data Filters Module",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "List",
        },
      ],
    };
  },
  mixins: [MixinRequest, datafilterMixin],
  components: {
    Layout,
    PageHeader,
  },
};
</script>
